import React from "react";
import { viewportOptions } from "./ResponsivePreview";

const PreviewControls = ({
  scenarios = [],
  selectedScenarioId,
  onScenarioChange,
  selectedViewport,
  onViewportChange
}) => {
  return (
    <div className="grid gap-3 rounded-lg border border-slate-200 bg-white p-3 md:grid-cols-2">
      <label className="text-sm text-slate-700">
        <span className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">
          Scenario
        </span>
        <select
          className="w-full rounded-md border border-slate-300 bg-white px-2 py-2 text-sm"
          value={selectedScenarioId}
          onChange={(event) => onScenarioChange(event.target.value)}
        >
          {scenarios.map((scenario) => (
            <option key={scenario.id} value={scenario.id}>
              {scenario.title}
            </option>
          ))}
        </select>
      </label>

      <label className="text-sm text-slate-700">
        <span className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">
          Viewport
        </span>
        <select
          className="w-full rounded-md border border-slate-300 bg-white px-2 py-2 text-sm"
          value={selectedViewport}
          onChange={(event) => onViewportChange(event.target.value)}
        >
          {viewportOptions.map((viewport) => (
            <option key={viewport.value} value={viewport.value}>
              {viewport.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};

export default PreviewControls;
